import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import HorizontalScrollBar from '../components/HorizontalScrollbar';
import Loader from './Loader';



const SimilarExercises = ({targetExercises, equipmentExercises}) => {

  return (
    <Box sx={{mt:{lg:'100px', xs:'0'}}}>
      <Typography variant='h3' mb={5}>
      Exercises that target the same muscle group
      </Typography>
      <Stack direction="row" sx={{p:'2', position:'relative'}}>
        {targetExercises.length ? <HorizontalScrollBar data={targetExercises} isBodyParts={false} />:<Loader/>}

      </Stack>
      <Typography variant='h3' mb={5}>
      Exercises that use the same equipment
      </Typography>
      <Stack direction="row" sx={{p:'2', position:'relative'}}>
        {equipmentExercises.length ? <HorizontalScrollBar data={equipmentExercises} isBodyParts={false} />:<Loader/>}

      </Stack>
    </Box>
  )
}

export default SimilarExercises